(function () {
    "use strict";

    var script = document.currentScript;
    var pixelId = script ? String(script.getAttribute("data-meta-pixel-id") || "").trim() : "";
    if (!pixelId) {
        return;
    }

    // The pixel's own script (fbevents.js) is ~108KB and was previously fetched the moment this file ran (near
    // DOMContentLoaded), competing with our own CSS/JS/hero-image for bandwidth during the slowest part of a load on
    // a weak connection. Nothing here is time-critical to the millisecond, so the actual bootstrap waits for idle
    // time; any event fired before that (a fast click, an instant lead submit) is queued locally and replayed once
    // the pixel is ready, so no event is lost.
    var pendingEvents = [];
    var bootstrapped = false;

    function bootstrapPixel() {
        if (bootstrapped) {
            return;
        }
        bootstrapped = true;

        if (!window.fbq) {
            var fbq = function () {
                fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
            };
            window.fbq = fbq;
            if (!window._fbq) {
                window._fbq = fbq;
            }
            fbq.push = fbq;
            fbq.loaded = true;
            fbq.version = "2.0";
            fbq.queue = [];

            var tag = document.createElement("script");
            tag.async = true;
            tag.src = "https://connect.facebook.net/en_US/fbevents.js";
            var firstScript = document.getElementsByTagName("script")[0];
            firstScript.parentNode.insertBefore(tag, firstScript);
        }

        window.fbq("init", pixelId);
        window.fbq("track", "PageView");
        pendingEvents.forEach(function (call) {
            window.fbq("track", call.name, call.parameters);
        });
        pendingEvents.length = 0;
    }

    var scheduleIdle = window.g3ScheduleIdleTask || function (fn) {
        if ("requestIdleCallback" in window) {
            window.requestIdleCallback(fn, { timeout: 3000 });
        } else {
            window.setTimeout(fn, 1500);
        }
    };
    scheduleIdle(bootstrapPixel);

    function trackStandardEvent(name, parameters) {
        if (bootstrapped) {
            if (typeof window.fbq === "function") {
                window.fbq("track", name, parameters || {});
            }
            return;
        }
        pendingEvents.push({ name: name, parameters: parameters || {} });
        bootstrapPixel();
    }

    window.g3TrackMetaPixelEvent = trackStandardEvent;

    window.addEventListener("g3:lead-submitted", function (event) {
        var detail = (event && event.detail) || {};
        trackStandardEvent("Lead", {
            content_name: "Website lead form",
            content_category: detail.source || "form",
        });
    });

    document.addEventListener(
        "click",
        function (event) {
            var target = event.target;
            if (!target || !target.closest) {
                return;
            }
            var link = target.closest("a[href]");
            if (!link) {
                return;
            }
            var href = String(link.getAttribute("href") || "").toLowerCase();
            if (href.indexOf("tel:") === 0 || href.indexOf("wa.me") !== -1 || href.indexOf("whatsapp") !== -1) {
                trackStandardEvent("Contact", {
                    content_name: href.indexOf("tel:") === 0 ? "Phone click" : "WhatsApp click",
                });
            }
        },
        true
    );
})();
